import React, { useEffect, useState } from 'react';
import Slideshow from '../../Components/Slideshow/Slideshow';
import { loadImagesDeviceFunction } from '../../firebase/functions';
import PropTypes from 'prop-types';
import { useSearchParams } from 'react-router-dom';
import styles from './Slideshow.module.css';

function SlideShow() {
  const [searchParams] = useSearchParams();
  const deviceId = searchParams.get('deviceId');

  const [images, setImages] = useState([]);
  const [facilityId, setFacilityId] = useState();
  const [text, settext] = useState('Loading...');

  const loadImages = () => {
    if (!deviceId) {
      settext('Invalid deviceId');
      return;
    }
    loadImagesDeviceFunction({
      deviceId: deviceId,
    })
      .then((result) => {
        const imgs = result.data.images.map((x) => ({ ...x, selected: false }));
        setImages(imgs);
        setFacilityId(result.data.facilityId);
        settext('');
      })
      .catch((error) => {
        settext(error?.message);
        setImages([]);
      });
  };

  useEffect(() => {
    loadImages();
  }, []);

  return (
    <div className={styles.slideshowContainer}>
      {text && <div>{text}</div>}
      {!text && <Slideshow images={images} facilityId={facilityId} full />}
    </div>
  );
}

SlideShow.propTypes = {};

export default SlideShow;
